<template>
  <div>
    <v-card flat class="pa-1">
      <v-tabs centered>
        <v-tab href="#tab-tabela-materia-prima">
          <v-icon left>mdi-clipboard-list-outline</v-icon>
          Listas de preços
        </v-tab>

        <v-tab-item
          class="ma-0"
          value="tab-tabela-materia-prima"
        >
          <TabelaCapaListas :pedido_selecionado="{}" />
        </v-tab-item>
      </v-tabs>
    </v-card>
  </div>
</template>

<script>
import TabelaCapaListas from './TabelaCapaListas.vue';
export default {
  components: { TabelaCapaListas }
}
</script>

<style>

</style>
